"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _modalLoader = _interopRequireWildcard(require("@wsb/modal-loader"));
var _Error = _interopRequireDefault(require("./components/Error"));
var _appPropTypes = _interopRequireDefault(require("./appPropTypes"));
var _config = _interopRequireDefault(require("./config"));
var _deps = _interopRequireDefault(require("./deps"));
var _reactDom = _interopRequireDefault(require("react-dom"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function getHostname() {
  if (typeof window !== 'undefined') {
    return window.location.hostname;
  }
  return '';
}
function getRootDomain() {
  var hostName = getHostname();
  var domainParts = hostName.split('.');
  var rootDomainParts = domainParts.reverse().slice(0, 2);
  var godaddyDomain = rootDomainParts.reverse().join('.');
  return godaddyDomain;
}
function DIFYLeadGenLoader(appProps) {
  var market = appProps.market;
  var props = _objectSpread(_objectSpread({}, _config["default"]), {}, {
    appProps: appProps,
    deps: _deps["default"],
    errorComponent: _Error["default"],
    loaderComponent: _modalLoader.DefaultLoader,
    market: market,
    rootDomain: getRootDomain()
  });
  return /*#__PURE__*/_react["default"].createElement(_modalLoader["default"], props);
}
DIFYLeadGenLoader.propTypes = _appPropTypes["default"];
var _default = exports["default"] = DIFYLeadGenLoader;
if (typeof window !== 'undefined') {
  window.difyLeadGen = {
    load: function load(loaderProps) {
      var _document$querySelect;
      var divContainer = document.createElement('div');
      divContainer.id = 'dify-lead-gen-loader';
      _reactDom["default"].render(/*#__PURE__*/_react["default"].createElement(DIFYLeadGenLoader, loaderProps), divContainer);
      (_document$querySelect = document.querySelector("#root")) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.prepend(divContainer);
    }
  };
}